export default {
  state: {
    id: undefined,
    purchased_at: undefined,
    buyer_user: {},
    recipient_user: {},
    payments: [],
    purchasable_item_id: undefined,
    purchasable_items: [],
    purchase_tags: [],
    relationships: {},
    subscriptions: [],
    tags: [],
    gift: undefined,
    status: undefined,
    customer_email: undefined,
    internal_notes: undefined,
    notes: undefined,
    gross: undefined,
    fee: undefined,
    net: undefined,
    created_at: undefined,
    updated_at: undefined,
    download_url: undefined,
    download_token: undefined,
    download_access_count: 0,
    download_purchase_urls: undefined,
    external_payment_id: undefined,
    external_payment_token: undefined,
    external_payment_url: undefined,
    external_payment_sale_id: undefined,
    external_payment_subscription_id: undefined,
    sandbox: true,
    external_payer_id: undefined,
    merchant_code: undefined,
    merchant_email: undefined,
    send_at: undefined,
    sent_at: undefined,
    recipient_email: undefined
  }
}



// WEBPACK FOOTER //
// ./src/stores/PurchaseStore.js